// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3SZq2","main-image":"Header_main-image__1-7VB"};